<template>
  <b-container
    fluid="md"
    data-cy="store-card-error"
    class="square-storecard-error"
  >
    <b-row>
      <b-col class="storecard-error-header">
        <div class="title">
          <font-awesome-icon
            icon="triangle-exclamation"
            size="2x"
            class="icon error-icon"
            fixed-width
          />
          Store Card Error
        </div>
        <div class="message">
          An error was encountered while attempting to store your credit card details.
          <br>
          Please check the reason for the error and try again.
          <br>
          If the error persists, please contact support.
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="error-details">
          <h3>Error details</h3>
          <div
            v-if="isErrorList"
            class="error-list"
          >
            <ul>
              <li
                v-for="(err, index) in error"
                :key="index"
                class="error-item"
              >
                <span
                  class="label"
                  data-cy="error-label"
                >
                  {{ err.field }}
                </span>
                <span
                  class="value"
                  data-cy="error-message"
                >
                  {{ err.message }}
                </span>
              </li>
            </ul>
          </div>

          <div
            v-else
            class="error-grid"
          >
            <template v-if="errorCode">
              <span class="label">Error code:</span>
              <span
                class="value"
                data-cy="error-code"
              >{{ errorCode }}</span>
            </template>
            <template v-if="errorMessage">
              <span class="label">Reason:</span>
              <span
                class="value"
                data-cy="error-message"
              >{{ errorMessage }}</span>
            </template>
          </div>
        </div>
      </b-col>
    </b-row>
    <square-response-debug-wrapper
      v-if="debug"
      :debug-data="debugData"
    />
  </b-container>
</template>

<script>
import CommonTxnFields from './common-txn-fields'
import DebugWrapper from './debug.vue'

export default {
  name: 'square-payment-storecard-error',
  components: {
    'square-response-debug-wrapper': DebugWrapper
  },
  mixins: [
    CommonTxnFields
  ],
  props: {
    debug: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function() {
    return {
      showDebug: false
    }
  },
  computed: {
    errorCode: function() {
      try {
        if (!!this.error && this.error.code) {
          return this.error.code
        }
        else {
          return false
        }
      }
      catch (_err) {
        return false
      }
    },
    errorMessage: function() {
      try {
        if (!!this.error && this.error.message) {
          return this.error.message
        }
        else {
          return false
        }
      }
      catch (_err) {
        return false
      }
    },
    error: function() {
      try {
        return this.$store.getters['square/processingResult'].error
      }
      catch (_err) {
        return '--'
      }
    },
    isErrorList: function() {
      try {
        return Array.isArray(this.$store.getters['square/processingResult'].error)
      }
      catch (_err) {
        return '--'
      }
    },
    debugData: function() {
      try {
        return this.$store.getters['square/processingResult']
      }
      catch (_err) {
        return '--'
      }
    }

  }
}
</script>

<style lang="scss" scoped>
  .storecard-error-header {
    .title {
      font-size: 2.2rem;
      margin-bottom: 1rem;
    }
    .message {
      font-size: 1rem;
      margin-bottom: 1rem;
    }
  }
  .error-details .error-grid {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 0.5rem;
  }
  .label {
    font-weight: bold;
  }
  .error-icon {
    color: red;
  }
</style>
